import { AnyType } from '@src/models/common';
import { StaticImageData } from '@src/models/ssr';
import { CSSProperties } from 'react';

type TDefaultProps = {
  src: string | HTMLImageElement['src'];
  alt: string;
  fill?: true;
  width?: number | string;
  height?: number | string;
};
type ReturnType<T> = T & TDefaultProps;

export const getDefaultProps = <T extends { [x: string]: AnyType } & { style?: CSSProperties }>({
  props,
  src,
  isNext,
  alt,
  ...size
}: {
  alt: string;
  isNext?: boolean;
  props: T;
  src: StaticImageData | string;
  width?: number;
  height?: number;
}): ReturnType<T> => {
  const height = size.height || props?.style?.height;
  const width = size.width || props?.style?.width;

  const defaultProps: ReturnType<T> = {
    ...props,
    src: src as HTMLImageElement['src'],
    alt,
    height,
    width,
  };

  /**
   * Заполняем только если нет высоты и ширины, тоже и в `style`.
   * Установка высоты и ширины через классы игнорируется, точнее не проверяется
   * */
  const fill = !Boolean(width || height || (typeof src === 'object' ? src?.height || src.width : false));
  return isNext && fill ? { ...defaultProps, fill } : defaultProps;
};

export const getIsExternalSrc = (src: string | StaticImageData) => {
  const preffix = 'http';
  if (typeof src === 'string') {
    return src.startsWith(preffix);
  }

  return src.src?.startsWith(preffix);
};
